































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import authProvider from '@/utility/authProvider';
import Loading from 'vue-loading-overlay';
import formatNumber from '@/shared/filters/format-number';
import formatDate from '@/shared/filters/format-date';
import authService from '@/services/auth-services';
import receiptServices from '@/services/receipt-services';
import { APP_CONFIG } from '@/config/app-config';

@Component({
    components: {
        Loading
    },
    filters: {
        formatNumber,
        formatDate
    }
})
export default class DetailReceipt extends Vue {
    private isLoading = false;
    private receipt: any = {};
    private listPackage: any[] = [];
    private customerInfo: any = {};

    get receiptId() {
        return this.$route.params.id;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    @Watch('receiptId', { immediate: true })
    private async watchReceiptId() {
        if (this.receiptId) {
            await this.initComponent();
        }
    }

    private async initComponent() {
        await Promise.all([
            this.getCustomersInfo(),
            this.loadData()
        ]);
    }

    private async getCustomersInfo() {
        if (!this.userInfo || !this.userInfo.userId) { return; }
        try {
            const result = await authService.customersInfo(this.userInfo.userId);
            if (result && result.status === 200) {
                this.customerInfo = result.data.data || {};
            }
        } catch (e) {
            // ignore
        }
    }

    private async loadData() {
        this.isLoading = true;
        try {
            const [receiptRes, packageRes] = await Promise.all([
                receiptServices.getDetail(this.receiptId),
                receiptServices.getBillOfLading(this.receiptId, authProvider.getToken())
            ]);

            if (receiptRes && receiptRes.data && receiptRes.data.status === 200) {
                this.receipt = receiptRes.data.data || {};
            }

            if (packageRes && packageRes.data && packageRes.data.status === 200) {
                const rawPackages = packageRes.data.data.order_transactions || [];
                this.listPackage = rawPackages.map((item: any) => ({
                    ...item,
                    matched: false,
                    Weight: parseFloat(item.Weight) || 0,
                    Volume: parseFloat(item.Volume) || 0,
                    WeightByVolume: parseFloat(item.WeightByVolume) || 0,
                    NumberOfPack: parseInt(item.NumberOfPack, 10) || 1
                }));
            }
        } catch (error) {
            // ignore
        } finally {
            this.isLoading = false;
        }
    }

    // Customer display
    get customerFullName(): string {
        const lastName = this.receipt.LastName || this.customerInfo.lastName || '';
        const firstName = this.receipt.FirstName || this.customerInfo.firstName || '';
        const fullName = (lastName + ' ' + firstName).trim();
        return fullName || this.receipt.Receiver || this.customerInfo.fullname || this.receipt.Username || '';
    }

    get customerUserCode(): string {
        return this.customerInfo.userCode || this.receipt.UserCode || this.customerInfo.username || '';
    }

    get warehouseName(): string {
        return this.receipt.WarehouseName || 'Kho HCM';
    }

    get receiptStatusName(): string {
        const map: { [key: string]: string } = {
            chuan_bi: 'Chuẩn bị xuất',
            cho_giao_lai: 'Chờ giao lại',
            dang_giao: 'Đang giao',
            da_xuat: 'Đã xuất',
            da_huy: 'Đã hủy'
        };
        const status = this.receipt.Status;
        return (status && map[status]) ? map[status] : (status ? String(status) : 'Đã xuất');
    }

    get shipPaymentTypeName(): string {
        const type = Number(this.receipt.ShipPaymentType !== undefined && this.receipt.ShipPaymentType !== null ? this.receipt.ShipPaymentType : 0);
        switch (type) {
            case 1:
                return 'Free ship';
            case 2:
                return 'Kho ship thu tiền mặt từ khách';
            case 3:
                return 'Shipper tự thu';
            case 0:
            default:
                return 'Trừ ví điện tử của khách';
        }
    }

    // Calculations
    private getChargeableWeight(pkg: any): number {
        const feeShipType = pkg.OrderFeeShipType !== undefined && pkg.OrderFeeShipType !== null ? Number(pkg.OrderFeeShipType) : 0;
        if (feeShipType === 0) {
            return parseFloat(pkg.Weight) || 0;
        }
        if (feeShipType === 1) {
            return parseFloat(pkg.Volume) || 0;
        }
        if (feeShipType === 2) {
            return parseFloat(pkg.WeightByVolume) || 0;
        }
        return Math.max(parseFloat(pkg.Weight) || 0, parseFloat(pkg.WeightByVolume) || 0) || parseFloat(pkg.Weight) || 0;
    }

    get totalAmount(): number {
        if (this.receipt.Status === 'da_huy') {
            return 0;
        }
        if (this.listPackage && this.listPackage.length > 0) {
            const groupedOrders: { [key: string]: any[] } = {};
            for (const p of this.listPackage) {
                if (Number(p.OrderID) > 0) {
                    const key = `${Number(p.PackageType) || 0}_${Number(p.OrderID)}`;
                    if (!groupedOrders[key]) {
                        groupedOrders[key] = [];
                    }
                    groupedOrders[key].push(p);
                }
            }
            const calculated = Object.values(groupedOrders).reduce((sum, pkgs) => {
                const remain = parseFloat(pkgs[0] && pkgs[0].OrderRemainAmount) || 0;
                return sum + Math.max(remain, 0);
            }, 0);
            if (calculated > 0) {
                return calculated;
            }
        }
        return parseFloat(this.receipt.LiquidationAmount) || 0;
    }

    get customerShipVN(): number {
        return parseFloat(this.receipt.ShipVN) || 0;
    }

    get currentWallet(): number {
        if (this.receipt.Wallet !== undefined && this.receipt.Wallet !== null) {
            return parseFloat(this.receipt.Wallet) || 0;
        }
        return parseFloat(this.customerInfo.wallet) || 0;
    }

    get payableShipVN(): number {
        const isPaidShip = Number(this.receipt.IsPaidShip) === 1;
        if (isPaidShip) { return 0; }
        const shipPaymentType = Number(this.receipt.ShipPaymentType !== undefined && this.receipt.ShipPaymentType !== null ? this.receipt.ShipPaymentType : 0);
        return shipPaymentType === 0 ? this.customerShipVN : 0;
    }

    get walletAfterExport(): number {
        return this.currentWallet - this.totalAmount - this.payableShipVN;
    }

    get sumRawWeight(): number {
        if (this.listPackage && this.listPackage.length > 0) {
            return this.listPackage.reduce((sum, p) => sum + (parseFloat(p.Weight) || 0), 0);
        }
        return parseFloat(this.receipt.Weight) || 0;
    }

    get sumVolume(): number {
        if (this.listPackage && this.listPackage.length > 0) {
            return this.listPackage.reduce((sum, p) => sum + (parseFloat(p.Volume) || 0), 0);
        }
        return parseFloat(this.receipt.Volume) || 0;
    }

    get sumWeightByVolume(): number {
        if (this.listPackage && this.listPackage.length > 0) {
            return this.listPackage.reduce((sum, p) => sum + (parseFloat(p.WeightByVolume) || 0), 0);
        }
        return 0;
    }

    get sumNumberOfPack(): number {
        if (this.listPackage && this.listPackage.length > 0) {
            return this.listPackage.reduce((sum, p) => sum + (parseInt(p.NumberOfPack, 10) || 1), 0);
        }
        return parseInt(this.receipt.NumberOfPack, 10) || 0;
    }

    get groupedPackages() {
        const groups: { [key: string]: any[] } = {};
        for (const p of this.listPackage) {
            const key = `${p.PackageType || 0}_${p.OrderID || 0}`;
            if (!groups[key]) {
                groups[key] = [];
            }
            groups[key].push(p);
        }

        return Object.keys(groups).map((key, index) => {
            const pkgs = groups[key];
            const subtotalWeight = pkgs.reduce((sum, p) => sum + (parseFloat(p.Weight) || 0), 0);
            const subtotalVolume = pkgs.reduce((sum, p) => sum + (parseFloat(p.Volume) || 0), 0);
            const subtotalWeightByVolume = pkgs.reduce((sum, p) => sum + (parseFloat(p.WeightByVolume) || 0), 0);
            const subtotalNumberOfPack = pkgs.reduce((sum, p) => sum + (parseInt(p.NumberOfPack, 10) || 1), 0);
            const subtotalChargeableWeight = pkgs.reduce((sum, p) => sum + this.getChargeableWeight(p), 0);

            return {
                orderKey: key,
                orderId: pkgs[0].OrderID,
                packageType: pkgs[0].PackageType,
                packages: pkgs,
                stt: index + 1,
                rowspan: pkgs.length,
                subtotalWeight,
                subtotalVolume,
                subtotalWeightByVolume,
                subtotalNumberOfPack,
                subtotalChargeableWeight
            };
        });
    }
}
